/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ heading: NonNullable<unknown>, body: NonNullable<unknown> }} Presentation_Template_Master_FontsInputs */



/**
* | output |
* | --- |
* | "Fonts: {heading} and {body}" |
*
* @param {Presentation_Template_Master_FontsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const presentation_template_master_fonts = /** @type {((inputs: Presentation_Template_Master_FontsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Presentation_Template_Master_FontsInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Schriften: ${i?.heading} und ${i?.body}`)
	return /** @type {LocalizedString} */ (`Fonts: ${i?.heading} and ${i?.body}`)
});